<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-view-claims-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ViewClaims',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreViewClaimsView: () => import('../components/core/ViewClaimsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
